export default __webpack_public_path__ + "images/HR.f2d1256.png";